import { useEffect, useRef } from "react";

/** Adds .pm-visible when element enters viewport */
export default function useReveal(options = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("pm-visible");
          el.querySelectorAll(".pm-reveal").forEach((child) => {
            child.classList.add("pm-visible");
          });
          if (options.once !== false) obs.disconnect();
        }
      },
      { threshold: options.threshold ?? 0.15, rootMargin: "0px 0px -40px 0px" }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, [options.once, options.threshold]);

  return ref;
}
